/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_step_card_description = /** @type {(inputs: {}) => string} */ () => {
	return `Usa tus fondos al instante con una tarjeta global y multi-moneda.`
};

const en_onboarding_step_card_description = /** @type {(inputs: {}) => string} */ () => {
	return `Use your funds instantly with a global, multi-currency card.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_step_card_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_step_card_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_step_card_description", locale)
	if (locale === "es") return es_onboarding_step_card_description(inputs)
	return en_onboarding_step_card_description(inputs)
};
export { onboarding_step_card_description as "onboarding.step_card.description" }